import React from "react";
import { LOGO_DARK_THEME, LOGO_LIGHT_THEME } from "../lib/constants";
import { useTheme } from "../context/ThemeContext";

/** Brand mark that swaps with the active theme. Dark theme → light logo, light theme → dark logo. */
export const Logo = ({ className = "w-9 h-9", alt = "ReHealthMe", forceVariant = null }) => {
    const ctx = useTheme();
    const theme = ctx?.theme || "dark";
    const variant = forceVariant || (theme === "light" ? "light" : "dark");
    const src = variant === "light" ? LOGO_LIGHT_THEME : LOGO_DARK_THEME;
    return <img src={src} alt={alt} data-testid="brand-logo" className={`${className} object-contain`} />;
};

export default Logo;
